import { UserAction, UserEvent } from '../constants/enums'
import { MfcCrc32 } from '../libraries/mfc/MfcCrc32'
import { pubSubUsers } from '../state/pubSub'
import { userAction } from './workerActions'

type SocketLookupPromiseUsername = {
    [identifier: string]: {
        resolve?: (value: boolean | PromiseLike<boolean>) => void
        promise?: Promise<boolean>
    }
}
type SocketLookupPromiseId = {
    [identifier: number]: {
        resolve?: (value: boolean | PromiseLike<boolean>) => void
        promise?: Promise<boolean>
    }
}
type SocketLookupPromises = SocketLookupPromiseUsername & SocketLookupPromiseId

type SocketLookupResult = {
    identifier: string | number
    exists: boolean
}

const socketLookupUserClosure = (promises: SocketLookupPromises = {}) => {
    pubSubUsers.on(UserEvent.SOCKET_LOOKUP, (event: SocketLookupResult) => {
        if (!event) return
        const { identifier, exists } = event
        promises[identifier]?.resolve?.(exists)
        delete promises[identifier]
    })
    return (identifier: string | number) => {
        if (typeof window === 'undefined') {
            return Promise.resolve<undefined>(undefined)
        }
        if (!identifier) {
            throw new Error('Slug or user ID is requred!')
        }
        if (typeof identifier === 'string') {
            identifier = identifier.toLowerCase()
        }
        if (promises[identifier]?.promise instanceof Promise) {
            return promises[identifier].promise
        }
        const now = String(Date.now())
        const reqId = Math.abs(MfcCrc32.string(String(identifier).concat(now)))
        promises[identifier] = { resolve: null, promise: null }
        promises[identifier].promise = new Promise<boolean>((resolve) => {
            promises[identifier].resolve = resolve
        })
        userAction(UserAction.SOCKET_LOOKUP_USER, { identifier, reqId })
        return promises[identifier].promise
    }
}

export const socketLookupUser = socketLookupUserClosure()
